<template>
    <div class="m-monitorScreen" id="m-monitorScreen">
        <div class="container">
            <header class="header">
                <img class="logo" src="../../assets/images/monitor/new-logo.png" alt="">
                <h1 class="title">{{systemInfo.name}}</h1>
                <clock class="clock"></clock>
            </header>

            <div class="content">
                <left-part ref="leftPart" />

                <section class="content-center">
                    <ul class="number-count">
                        <li class="number-item">
                            <div class="circle">{{onlineNum.onlineCount}}</div>
                            <h4 class="num">实时培训人数</h4>
                        </li>
                        <li class="number-item">
                            <div class="circle">{{onlineNum.courseCount}}</div>
                            <h4 class="num">实时学习人数</h4>
                        </li>
                        <li class="number-item">
                            <div class="circle">{{onlineNum.examCount}}</div>
                            <h4 class="num">实时考试人数</h4>
                        </li>
                        <li class="number-item">
                            <div class="circle">{{onlineNum.mockCount}}</div>
                            <h4 class="num">实时模考人数</h4>
                        </li>
                        <li class="number-item">
                            <div class="circle">{{onlineNum.practiceCount}}</div>
                            <h4 class="num">实时练习人数</h4>
                        </li>
                    </ul>

                    <div class="studen-list-wrap">
                        <transition-group tag="ul" class="student-list"
                                          name="student-list"
                                          v-if="studentData.length">
                            <li class="student-item-wrap" v-for="item in studentData" :key="item.id">
                                <a class="student-item" @click="sendMsgToStudent(item)" :title="item.name">
                                    <img v-if="item.avatar" class="avatar" :src="item.avatar" alt="">
                                    <img v-else class="avatar" src="../../assets/images/common/default_avatar.jpg" alt="">
                                    <div class="detail">
                                        <p>{{item.orgName}}</p>
                                        <h3>{{item.name}}</h3>
                                    </div>
                                </a>
                            </li>
                        </transition-group>
                        <div class="nodata" v-else>
                            <img src="../../assets/images/monitor/nodata.png" alt="">
                            <p>当前环节无人在线</p>
                        </div>
                    </div>

                    <ul class="tab-online">
                        <li class="tab-btn" @click="tabClick(1)" :class="{'active': tab==1}">
                            <p class="tab-btn-icon"></p>
                            <h4 class="tab-btn-text">在线考试</h4>
                        </li>
                        <li class="tab-btn" @click="tabClick(2)" :class="{'active': tab==2}">
                            <p class="tab-btn-icon"></p>
                            <h4 class="tab-btn-text">在线学习</h4>
                        </li>
                        <li class="tab-btn" @click="tabClick(3)" :class="{'active': tab==3}">
                            <p class="tab-btn-icon"></p>
                            <h4 class="tab-btn-text">在线练习</h4></li>
                    </ul>
                </section>

                <right-part ref="rightPart" />
            </div>

        </div>

        <el-alert
            class="screen-alert-tip"
            title="当前设备分辨率较低"
            description="由于设备分辨率问题，已隐藏部分内容。若您的设备为平板，请切换到横屏，以获得最佳的浏览体验"
            type="warning">
        </el-alert>

        <div class="btn-close" @click="close" title="退出大屏">
            <i class="nucfont inuc-close"></i>
        </div>

    </div>
</template>

<script>
    /**
     * todo:
     * 2、优化图片
     */
    import {mapGetters} from 'vuex'
    import {screenfull} from '@/utils'
    import Clock from "./Components/Clock"
    import LeftPart from "./Components/LeftPart"
    import RightPart from "./Components/RightPart"

    let echarts = require('echarts')

    export default {
        components: {
            Clock,
            LeftPart,
            RightPart
        },

        data() {
            return {
                onlineNum: {
                    onlineCount: "0",
                    courseCount: "0",
                    examCount: "0",
                    mockCount: "0",
                    practiceCount: "0"
                },
                tab: 1,
                studentData: [],
                examData: null,
                courseData: null,
                practiceData: null,
            }
        },

        computed: {
            ...mapGetters([
                'wsBrowser',
                'systemInfo',
            ]),
        },

        watch: {
            wsBrowser: {
                handler(hasConnected) {
                    if (hasConnected) {
                        this.initWSSender()
                        this.initWSListener()
                    }
                },
                immediate: true
            },

            tab(n) {
                if (n == 1) {
                    // 发送在线考试情况请求
                    this.wsBrowser.send('SGetOnlineExam')
                }

                if (n == 2) {
                    // 发送在线学习情况请求
                    this.wsBrowser.send('SGetOnlineCourse')
                }

                if (n == 3) {
                    // 发送在线练习情况请求
                    this.wsBrowser.send('SGetOnlinePractice')
                }
            }
        },

        mounted() {
            this.setHTMLFontsize()

            this.handleResize()
        },

        methods: {
            initWSListener() {
                // 获取在线人数
                this.wsBrowser.on('ROnline', (data) => {
                    console.info(data, '在线人数')
                    this.onlineNum = data
                })

                // 获取在线考试情况
                this.wsBrowser.on('ROnlineExam', (data) => {
                    if (this.tab != 1) return
                    console.info(data, '在线考试')

                    this.studentData = data
                })

                // 获取在线学习情况
                this.wsBrowser.on('ROnlineCourse', (data) => {
                    if (this.tab != 2) return
                    console.info(data, '在线学习')

                    this.studentData = data
                })

                // 获取在线练习情况
                this.wsBrowser.on('ROnlinePractice', (data) => {
                    if (this.tab != 3) return
                    console.info(data, '在线练习')

                    this.studentData = data
                })

                this.wsBrowser.on('RJoinExam', (user) => {
                    if (this.tab != 1) return
                    console.info(user, '加入考试')
                    this.addUser(user)
                })
                this.wsBrowser.on('RJoinCourse', (user) => {
                    if (this.tab != 2) return
                    console.info(user, '加入学习')
                    this.addUser(user)
                })
                this.wsBrowser.on('RJoinPractice', (user) => {
                    if (this.tab != 3) return
                    console.info(user, '加入练习')
                    this.addUser(user)
                })

                this.wsBrowser.on('RLeaveExam', (user) => {
                    if (this.tab != 1) return
                    console.info(user, '离开考试')
                    this.dropUser(user)
                })
                this.wsBrowser.on('RLeaveCourse', (user) => {
                    if (this.tab != 2) return
                    console.info(user, '离开学习')
                    this.dropUser(user)
                })
                this.wsBrowser.on('RLeavePractice', (user) => {
                    if (this.tab != 3) return
                    console.info(user, '离开练习')
                    this.dropUser(user)
                })

                // 学员回应消息
                this.wsBrowser.on('RFeedback', (id, name, message) => {
                    //this.$message.info(`${name}已应答`)

                    this.$notify({
                        title: `${name} 已完成打卡`,
                        type: 'success',
                        duration: 5000
                    });
                })
            },

            initWSSender() {
                // 发送在线人数请求
                this.wsBrowser.send('SGetOnline')
                this.onlineNumTimer = setInterval(() => {
                    this.wsBrowser.send('SGetOnline')
                }, 3000)

                // 开始监听人员变动
                this.wsBrowser.send('SMonitor')

                // 发送在线考试情况请求
                this.wsBrowser.send('SGetOnlineExam')
            },

            addUser(user) {
                if (this.studentData.find(item => item.id === user.id)) return
                this.studentData.push(user)
            },
            dropUser(user) {
                let index = this.studentData.findIndex(item => item.id === user.id)
                if (index > -1) {
                    this.studentData.splice(index, 1)
                }
            },

            sendMsgToStudent({name, id}) {
                this.$confirm(`点击发送后将会向
                             <strong>${name}</strong>
                            发送弹窗打卡消息`, '弹窗打卡', {
                    type: 'warning',
                    confirmButtonText: '发送',
                    dangerouslyUseHTMLString: true
                }).then(() => {
                    this.wsBrowser.send('SMessage', id, '')
                }).catch(() => {
                })
            },

            tabClick(n) {
                if (this.tab == n) return

                this.tab = n
            },

            handleResize() {
                // 监听 esc 按键触发
                $(window).on('resize.monitor', e => {
                    this.setHTMLFontsize()

                    this.$refs.leftPart.resizeChart()
                    this.$refs.rightPart.resizeChart()

                    if (!screenfull.isFull()) {
                        //this.close()
                    }
                })
            },

            setHTMLFontsize() {
                this.$nextTick(() => {
                    let deviceWidth = document.documentElement.clientWidth;
                    let htmlFontsize = deviceWidth / 19.2

                    // 低于1366以下分辨率屏幕的展示
                    if (htmlFontsize <= 70) {
                        htmlFontsize = 70
                    }

                    document.documentElement.style.fontSize = htmlFontsize +'px';
                    //this.$message.success(htmlFontsize+' '+deviceWidth+' '+document.documentElement.clientHeight)
                })
            },

            close() {
                $(window).off('resize.monitor')
                screenfull.exit()
                this.$router.back()
            }
        },

        beforeDestroy() {
            $(window).off('resize.monitor')
            document.documentElement.style.fontSize = ''
            clearInterval(this.onlineNumTimer)

            // 取消监听人员变动
            this.wsBrowser.send('SCancelMonitor')

            // 取消所有监听事件
            this.wsBrowser.off('ROnline')
            this.wsBrowser.off('ROnlineExam')
            this.wsBrowser.off('ROnlineCourse')
            this.wsBrowser.off('ROnlinePractice')
            this.wsBrowser.off('RJoinExam')
            this.wsBrowser.off('RJoinCourse')
            this.wsBrowser.off('RJoinPractice')
            this.wsBrowser.off('RLeaveExam')
            this.wsBrowser.off('RLeaveCourse')
            this.wsBrowser.off('RLeavePractice')
            this.wsBrowser.off('RFeedback')
        },
    }
</script>

<style lang="scss">
    @import "~@/style/const";
    @import "MediaQuery";

    .m-monitorScreen {
        position: fixed;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: url(../../assets/images/monitor/bg.jpg) no-repeat center;
        background-size: cover;

        .container {
            display: flex;
            flex-direction: column;
            height: 100%;
            color: #fff;
            @include scrollbar(rgba(118, 185, 236, .1), 8px, 8px, rgba(118, 185, 236, .3));
        }

        .header {
            position: relative;
            height: 90px;
            font-size: .38rem;
            letter-spacing: 4px;
            text-align: center;

            .logo {
                position: absolute;
                left: 25px;
                bottom: 5px;
            }

            .title {
                padding: 0 100px;
                line-height: 90px;
                background: url(../../assets/images/monitor/top.png) no-repeat center -5%;
                background-size: 1701px;
            }

            .clock {
                position: absolute;
                right: 25px;
                bottom: 14px;
                font-size: .24rem;
            }
        }

        .content {
            flex: 1;
            display: flex;
            padding: 10px 20px 0 20px;
            min-height: 0;
        }

        .chart-box {
            position: relative;
            overflow: hidden;
            background: url(../../assets/images/monitor/box-bg.png) no-repeat center;
            background-size: contain;

            .chart-title {
                position: absolute;
                top: 2vh;
                left: 4vh;
                font-size: .18rem;
                font-weight: 600;
                letter-spacing: 1px;
            }

            .chart-map {
                height: 100%;
            }
        }

        .content-center {
            //flex: 3.7;
            flex: 1;
            display: flex;
            flex-direction: column;

            .number-count {
                display: flex;
                justify-content: center;

                .number-item {
                    padding: 0 22px;
                }

                .circle {
                    width: 9vh;
                    height: 9vh;
                    line-height: 9vh;
                    font-size: .18rem;
                    text-align: center;
                    font-weight: 600;
                    letter-spacing: 1px;
                }

                .num {
                    margin-top: 8px;
                    font-size: .16rem;
                    text-align: center;
                    font-weight: 600;
                }

                @for $i from 1 through 5 {
                    .number-item:nth-child(#{$i}) .circle {
                        background: url(../../assets/images/monitor/circle#{$i}.png) no-repeat center;
                        background-size: contain;
                    }
                }
            }

            .studen-list-wrap {
                position: relative;
                margin-top: 20px;
                padding: 10px;
                flex: 1;
                overflow: auto;
            }

            .student-list {
                display: flex;
                flex-wrap: wrap;
            }

            .student-list-enter, .student-list-leave-to {
                opacity: 0;
                transform: translateY(30px);
            }
            .student-list-leave-active {
                position: absolute;
            }

            .student-item-wrap {
                width: 16.6%;
                margin-bottom: 25px;
                transition: all .5s;
            }

            .student-item {
                display: block;
                width: 100px;
                height: 147px;
                padding: 10px 0;
                margin: 0 auto;
                text-align: center;
                background: url(../../assets/images/monitor/student_bg.png) no-repeat center;
                cursor: pointer;

                .avatar {
                    width: 80px;
                    height: 80px;
                    object-fit: contain;
                }

                .detail {
                    padding: 0 5px;
                    p {
                        margin-top: 7px;
                        font-size: .14rem;
                        @include no-wrap();
                    }

                    h3 {
                        margin-top: 5px;
                        font-size: .18rem;
                        @include no-wrap();
                    }
                }
            }

            .nodata {
                position: absolute;
                top: 45%;
                left: 50%;
                transform: translate(-50%, -50%);
                p {
                    margin-top: 10px;
                    text-align: center;
                    font-size: .24rem;
                    letter-spacing: 1px;
                }
            }

            .tab-online {
                display: flex;
                justify-content: center;
                height: 11vh;
                margin: 0 10px;
                background: url(../../assets/images/monitor/bottom.png) no-repeat center 0;
                background-size: contain;
            }

            .tab-btn {
                width: 148px;
                margin: 0 25px;
                cursor: pointer;

                .tab-btn-icon {
                    width: 6vh;
                    height: 6vh;
                    margin: 1vh auto 0 auto;
                    opacity: 0.7;
                    background: url(../../assets/images/monitor/icon-test-a.png) no-repeat center;
                    background-size: contain;
                    transition: all .3s;
                }

                .tab-btn-text {
                    margin-top: 6px;
                    font-size: .18rem;
                    color: #5ABCFF;
                    text-align: center;
                    transition: all .3s;
                }

                &:nth-child(2) .tab-btn-icon {
                    background-image: url(../../assets/images/monitor/icon-study-a.png);
                }

                &:nth-child(3) .tab-btn-icon {
                    background-image: url(../../assets/images/monitor/icon-mock-a.png);
                }

                &.active {
                    background: linear-gradient(0deg, rgba(67, 149, 255, 0.6), rgba(3, 169, 255, 0));
                    border-bottom: 6px solid #00FFFF;

                    .tab-btn-icon {
                        opacity: 1;
                    }

                    .tab-btn-text {
                        color: #fff;
                    }
                }
            }
        }


        .btn-close {
            position: absolute;
            width: 90px;
            height: 90px;
            right: -45px;
            top: -45px;
            background-color: #11487b;
            border-radius: 50%;
            cursor: pointer;
            overflow: hidden;
            transition: background-color 0.15s;
            &:hover {
                background-color: lighten(#11487b, 10%);
            }
            .nucfont {
                position: absolute;
                color: #fff;
                left: 18px;
                bottom: 18px;
            }
        }

        .screen-alert-tip {
            position: absolute;
            bottom: 0;
            display: none;
        }
    }

</style>
